var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-button',{class:("topic-btn " + (_vm.active ? 'active' : '')),style:(_vm.active ? { backgroundColor: ("" + _vm.color)} : ''),on:{"click":function (){ return _vm.onHandle(); }}},[_vm._v(_vm._s(_vm.name))])}
var staticRenderFns = []

export { render, staticRenderFns }